import {
  BuildingLibraryIcon,
  NewspaperIcon,
  ClipboardDocumentListIcon,
} from "@heroicons/react/24/solid";
import FeeLevel from "./FeeLevel";
import FeeType from "./FeeType";
import Terms from "./Terms";
import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";

export const PolicyTermTabs = [
  {
    path: ROUTE_PATHS.Utilities_PolicyTerm_FeeLevel_Index,
    to: ROUTE_PATHS.Utilities_PolicyTerm_FeeLevel_Index,
    icon: <BuildingLibraryIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Fee Level",
    component: FeeLevel,
    permission: PERMISSIONS.permission_utilities_policyterm_feelevel_view,
  },
  {
    path: ROUTE_PATHS.Utilities_PolicyTerm_FeeType_Index,
    to: ROUTE_PATHS.Utilities_PolicyTerm_FeeType_Index,
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Fee Type",
    component: FeeType,
    permission: PERMISSIONS.permission_utilities_policyterm_feetype_view,
  },
  {
    path: ROUTE_PATHS.Utilities_PolicyTerm_Terms_Index,
    to: ROUTE_PATHS.Utilities_PolicyTerm_Terms_Index,
    icon: <ClipboardDocumentListIcon className="h-4 w-4 float-left mr-2" />,
    title: "Terms",
    component: Terms,
    permission: PERMISSIONS.permission_utilities_policyterm_terms_view,
  },
];
